export default "__VITE_ASSET__BR15BQp8__"